import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EstampRoutingModule } from './estamp-routing.module';
import { EStampDashboardComponent } from './e-stamp-dashboard/e-stamp-dashboard.component';
import { EstampCustomerComponent } from './estamp-customer/estamp-customer.component';
import { InventoryComponent } from './inventory/inventory.component';
import { ClientOrderComponent } from './client-order/client-order.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetModule } from 'src/app/shared/widget/widget.module';
import { SimplebarAngularModule } from 'simplebar-angular';
import { UiModule } from 'src/app/shared/ui/ui.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedModule as PrimeNgSharedModule } from 'primeng/api';
import { NgPipesModule } from 'ngx-pipes';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgStepperModule } from 'angular-ng-stepper';
import { NgbDropdownModule, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { StateComponent } from './state/state.component';
import { UserComponent } from './user/user.component';
import { ClientOrderDetailComponent } from './client-order/client-order-detail/client-order-detail.component';


@NgModule({
  declarations: [
    EStampDashboardComponent,
    EstampCustomerComponent,
    InventoryComponent,
    ClientOrderComponent,
    StateComponent,
    UserComponent,
    ClientOrderDetailComponent
  ],
  imports: [
    CommonModule,
    EstampRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    WidgetModule,
    SimplebarAngularModule,
    UiModule,
    SharedModule,
    PrimeNgSharedModule,
    NgPipesModule,
    CdkStepperModule,
    NgStepperModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgApexchartsModule,
    CKEditorModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    CalendarModule,
  ],
  exports: [EStampDashboardComponent]
})
export class EstampModule { }
